import { useState } from 'react';

import InputI18n, { InputI18nProps } from 'components/molecules/InputI18n';
import { isFunction } from 'utils/common';

interface InputI18nWithStateProps extends InputI18nProps {
  callback?: (text: string) => void;
  className?: string;
  initialState?: string;
  includeUserData?: boolean;
}

function InputI18nWithState({ callback, className, initialState, includeUserData, ...rest }: InputI18nWithStateProps) {
  const [value, setValue] = useState(initialState);

  const handleChange = (e) => setValue(e.target.value);

  return (
    <InputI18n
      className={className}
      onBlur={() => callback && callback(value)}
      onChange={handleChange}
      onShortenUrl={(text) => {
        if (isFunction(callback)) callback(text);
        setValue(text);
      }}
      onAddUserData={
        includeUserData
          ? (text) => {
              if (isFunction(callback)) callback(value + text);
              setValue(value + text);
            }
          : undefined
      }
      value={value}
      {...rest}
    />
  );
}

export default InputI18nWithState;
